import { Block } from 'ui-kit/blocks'
import { Heading, Text } from 'ui-kit/typography'
import NewConnectorsImg from './image.svg'
import classes from './SolutionRequest.module.scss'

export const SolutionRequest = () => {
  return (
    <Block as={'section'} pad={'base'} className={classes.section}>
      <img
        className={classes.image}
        src={NewConnectorsImg.src}
        alt='Add new connectors'
        loading='lazy'
        width={277}
        height={81}
      />
      <Heading as={'h2'} size={'xl'} center balance className={classes.title}>
        Add new connectors on 2-weeks notice
      </Heading>
      <Text size={'lg'} center balance className={classes.subtitle}>
        Customer requests a new data source or destination? Not a problem. With
        our Al-powered connector builder and professional services you can ship
        new connectors on predictable timeline with short lead time
      </Text>
    </Block>
  )
}
